/* Script delivered from Nugg.ad as is. Ignoring jshint errors */
/* jshint ignore:start */
import defineComponent from 'flight';

function Nuggad() {
    this.after('initialize', function () {
        function nuggadReady() {
            // all nugg.ad calls are finsished.
            // you can put follow-up code here
        }

        /*
        This code checks the user-agent, for desktop, phone or tablets
        the var nuggPF stores the platform: dektop, phone, tablets
        phones and tablets will recieve the the mobile tag with different network/siteids
        */


        // Start Client Configuration
        let nuggtg = encodeURIComponent('');

        // Host for desktop
        let nugghost = '//trase.nuggad.net';
        // host for mobile
        let nugghostmobile = '//trase.nuggad.net';

        var nuggn = 1751692510;
        var nuggsid = 1758624136;

        let nuggnmobile = nuggn;
        let nuggsidmobile = 1455427789;

        let nuggntablet = nuggn;
        let nuggsidtablet = 1027173224;
        // End Client Configuration


        let nuggPF = 'desktop';
        let nuggUA = navigator.userAgent;
        let nuggadios = navigator.userAgent.match(/iPhone|iPad|iPod/i);

        if (nuggUA.match(/iphone/i)) {
            nuggPF = 'phone';
        }
        if (nuggUA.match(/ipad/i)) {
            nuggPF = 'tablet';
        }
        if (nuggUA.match(/android/i)) {
            if (nuggUA.match(/mobile/i)) {
                nuggPF = 'phone';
            } else {
                nuggPF = 'tablet';
            }
        }
        if (nuggUA.match(/BlackBerry/i) || nuggUA.match(/PlayBook/i) || nuggUA.match(/BB1/i)) {
            if (nuggUA.match(/Mobile/i)) {
                nuggPF = 'phone';
            } else {
                nuggPF = 'tablet';
            }
        }
        if (nuggUA.match(/Windows nt/i) && (nuggUA.match(/touch/i) || nuggUA.match(/mobile/i))) {
            if (nuggUA.match(/windows phone/i)) {
                nuggPF = 'phone';
            } else {
                nuggPF = 'tablet';
            }
        }

        let nuggadmobile = (nuggPF == 'tablet' || nuggPF == 'phone');
        if (nuggadmobile) {
            if (nuggPF == 'tablet') {
                var nuggn = nuggntablet;
                var nuggsid = nuggsidtablet;
            } else {
                var nuggn = nuggnmobile;
                var nuggsid = nuggsidmobile;
            }
        }

        if (nuggadios) {

            (function () {
                let nuggscr = document.createElement('script'); nuggscr.type = 'text/javascript'; nuggscr.async = true;
                nuggscr.src = nugghostmobile + '/javascripts/nuggad-ls.js';
                let n = document.getElementsByTagName('script')[0]; n.parentNode.insertBefore(nuggscr, n);
                nuggscr.onreadystatechange = function () {
                    nuggad.init({ 'rptn-url': nugghostmobile }, function (api) {
                        api.rc({ 'nuggn': nuggn, 'nuggsid': nuggsid, 'nuggtg': nuggtg },
                            nuggadReady);
                    });
                }
                nuggscr.onload = function () {
                    nuggad.init({ 'rptn-url': nugghostmobile }, function (api) {
                        api.rc({ 'nuggn': nuggn, 'nuggsid': nuggsid, 'nuggtg': nuggtg },
                            nuggadReady);
                    });
                }
            })();
        } else {
            (function () {
                let nuggscr = document.createElement('script'); nuggscr.type = 'text/javascript'; nuggscr.async = true;
                nuggscr.onload = nuggadReady;
                nuggscr.onreadystatechange = function () { if (this.readyState == 'complete') { nuggadReady(); } }
                nuggscr.src = nugghost + '/rc?nuggn=' + nuggn + '&nuggsid=' + nuggsid + '&nuggtg=' + nuggtg;
                let n = document.getElementsByTagName('script')[0]; n.parentNode.insertBefore(nuggscr, n);
            })();
        }

        this.on(document, 'nuggad:on-add-to-wish-list', function (evt, payload) {
            if (payload !== null && typeof payload !== 'undefined' && payload.categoryId !== null && typeof payload.categoryId !== 'undefined') {
                let imgElement = document.createElement('img');
                imgElement.src = '//tradse-dp.nuggad.net/dp?dp=8585&vl_wish=' + payload.categoryId;
                imgElement.height = 1;
                imgElement.width = 1;
                imgElement.style.position = 'absolute';
                imgElement.style.visibility = 'hidden';
                document.getElementById('view').appendChild(imgElement);
            }
        });
    });

}

module.exports = defineComponent.component(Nuggad);
/* jshint ignore:end */


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/layout/ads/nuggad.js